<script lang="ts">
  import { getContext, createEventDispatcher } from "svelte";
  import type { Readable } from "svelte/store";
  import type { Control } from "../../forms/controls";

  export let label: string;
  export let icon: string;
  export let value: any;
  export let disabled: boolean = false;

  const changes = getContext<Readable<Control>>("ToggleButtons");
  $: ctrl = $changes;

  const dispatch = createEventDispatcher();

  function handleClick() {
    let array = Array.isArray(ctrl.value) ? [...ctrl.value] : [];

    if (array.includes(value)) {
      array = array.filter((_) => _ !== value);
    } else {
      array.push(value);
    }

    ctrl.value = array;

    dispatch("change", { value, selected: array.includes(value) });
  }
</script>

<button type="button" class="toggle-button" class:active={Array.isArray(ctrl.value) ? ctrl.value.includes(value) : false} on:click={handleClick} {disabled}>
  <div>
    <img src={icon} alt={""} role="presentation" />
    <span>{label}</span>
  </div>
</button>

<style lang="scss">
  @import "./../_mixins.scss";

  .toggle-button {
    color: #000;
    text-align: center;
    vertical-align: middle;
    cursor: pointer;
    user-select: none;
    background-color: transparent;
    border: none;
    font-weight: 400;
    font-size: 15px;
    line-height: 1.4;
    //
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0.6rem 1rem;
    outline: none !important;

    &:hover {
      background-color: rgba(#000, 0.08);
    }

    &:active,
    &.active {
      background-color: rgba(#ffbc00, 0.5);
      border-color: #ffbc00;
    }

    &:disabled {
      background: rgba(#000, 0.04);
      border-color: #d9d9d9;

      > div {
        opacity: 0.35;
      }
    }

    div {
      display: flex;
      flex-flow: column;
      align-items: center;
    }

    img {
      width: 2rem;
      height: 2rem;
      object-fit: contain;
      margin-bottom: 0.2rem;
    }

    span {
      text-align: center;
    }

    @include media-breakpoint-mobile {
      img {
        width: 3rem;
        height: 3rem;
      }
      span {
        font-size: 14px;
      }
    }
  }
</style>
